import { render, staticRenderFns } from "./ClientSelect.vue?vue&type=template&id=6b1e158c&scoped=true&"
import script from "./ClientSelect.vue?vue&type=script&lang=js&"
export * from "./ClientSelect.vue?vue&type=script&lang=js&"
import style0 from "./ClientSelect.vue?vue&type=style&index=0&id=6b1e158c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1e158c",
  null
  
)

export default component.exports